(function() {
  window.initializeScrollingPromo = function(promoId) {
    const promoElement = document.querySelector(`.scrolling-promo[data-promo-id="${promoId}"]`);
    if (!promoElement) return;

    const contentElement = promoElement.querySelector('.scrolling-promo__content');
    const trackElement = promoElement.querySelector('.scrolling-promo__track');
    
    if (!contentElement || !trackElement) return;

    function updateScrollSpeed() {
      const contentWidth = contentElement.scrollWidth / 2;
      const trackWidth = trackElement.offsetWidth;
      const baseSpeed = parseInt(contentElement.dataset.scrollSpeed) || 20;
      
      const speedMultiplier = Math.max(0.5, Math.min(2, contentWidth / 1000));
      const adjustedSpeed = baseSpeed * speedMultiplier;
      
      contentElement.style.animationDuration = adjustedSpeed + 's';
    }

    updateScrollSpeed();

    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(updateScrollSpeed, 150);
    });

    const promoContainer = promoElement.querySelector('.scrolling-promo__container');
    if (promoContainer && !promoContainer.classList.contains('scrolling-promo--static')) {
      promoContainer.addEventListener('mouseenter', function() {
        contentElement.style.animationPlayState = 'paused';
      });
      
      promoContainer.addEventListener('mouseleave', function() {
        contentElement.style.animationPlayState = 'running';
      });
    }
  }
  
  function init() {
    const promoElements = document.querySelectorAll('.scrolling-promo');
    promoElements.forEach(function(el) {
      const promoId = el.dataset.promoId;
      if (promoId) {
        window.initializeScrollingPromo(promoId);
      }
    });
  }
  
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function(event) {
    const promoElements = document.querySelectorAll('.scrolling-promo');
    promoElements.forEach(function(el) {
      const promoId = el.dataset.promoId;
      if (promoId && event.target.contains(el)) {
        setTimeout(function() {
          window.initializeScrollingPromo(promoId);
        }, 100);
      }
    });
  });
  
  document.addEventListener('shopify:section:reorder', function() {
    setTimeout(function() {
      const promoElements = document.querySelectorAll('.scrolling-promo');
      promoElements.forEach(function(el) {
        const promoId = el.dataset.promoId;
        if (promoId) {
          window.initializeScrollingPromo(promoId);
        }
      });
    }, 100);
  });
})();
